import { useCallback, useEffect, useRef } from 'react';
import { playerRepository } from '../../data/playerRepository';
import type { FilaJukebox, PlaylistItem } from '@/shared/types';

export interface UseYoutubeErroEmbedParams {
  telaId: string | undefined;
  pedidoAtualRef: React.RefObject<FilaJukebox | null>;
  playlistItemsRef: React.RefObject<PlaylistItem[]>;
  ytIndexRef: React.RefObject<number>;
}

/**
 * Handler de erro do YoutubeSlide (Jukebox/playlist).
 * Pedido do cliente → conclui no banco (exceto invasão virtual).
 * Playlist com erro 100/101/150 → marca erro_embed via RPC.
 */
export function useYoutubeErroEmbed({
  telaId,
  pedidoAtualRef,
  playlistItemsRef,
  ytIndexRef,
}: UseYoutubeErroEmbedParams): (code: number) => void {
  const handlerRef = useRef<(code: number) => void>(() => {});

  useEffect(() => {
    handlerRef.current = (code: number) => {
      const pedido = pedidoAtualRef.current;
      console.warn(`[Player] Erro YouTube ${code}${pedido ? ' — pedido do cliente' : ''}`);
      if (pedido) {
        if (!pedido.is_invasao_tematica) {
          playerRepository.atualizarStatusJukebox(pedido.id, 'concluido', telaId ?? '')
            .catch(err => console.warn('[Player] erro YT concluir pedido:', err));
        }
      } else if (code === 100 || code === 101 || code === 150) {
        const item = playlistItemsRef.current[ytIndexRef.current];
        if (item && telaId) {
          playerRepository.marcarErroEmbed(telaId, item.id)
            .catch(err => console.warn('[Player] marcarErroEmbed:', err));
        }
      }
    };
  });

  return useCallback((code: number) => {
    handlerRef.current(code);
  }, []);
}
